<template>
	<div class="wrapper">
		<top-bar/>
		<side-bar :disabledOptions="showNoData"/>
		<transition name="fade" mode="out-in">
			<router-view/>
		</transition>
	</div>
</template>

<script>
export default {
	computed: {
		showNoData () {
			return this.$store.state.ui.showNoData;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/admin/Admin.vue